import React from "react";
import {StaticFieldDisplayProps} from "../staticFieldUtils.ts";
import {
    FormError,
    FormLabel, getInputClassNames, getInputWrapperClass, getWholeDivWrapperClass,
} from "../../sharedStyles.tsx";



const StaticDateRenderer: React.FC<StaticFieldDisplayProps> = ({ component, value, controller }) => {
    const date = new Date(value);
    const formattedValue = date.getTime() ? date.toISOString().split('T')[0] : "-";
    const {fieldState} = controller;

    return (
        <div className={getWholeDivWrapperClass(component)}>
            <FormLabel component={component}></FormLabel>
            <div className={getInputWrapperClass(component)}>
                <input
                    id={component.fieldKey}
                    type="date"
                    value={formattedValue}
                    disabled
                    className={getInputClassNames(component, )}
                />
            </div>
            <FormError fieldState={fieldState} component={component}></FormError>
        </div>

    );
};

export const StaticDate = React.memo(StaticDateRenderer);